import { PostHogProvider } from 'posthog-js/react';

const DEFAULT_DATE = '2025-05-24';
const posthogOptions = {
    api_host: process.env.POSTHOG_API_URL,
    defaults: DEFAULT_DATE,
};

const PostHogWrapper = ({ children }: { children: React.ReactNode }) => {
    if (process.env.POSTHOG_ENABLED === 'ENABLED') {
        return (
            <PostHogProvider apiKey={process.env.POSTHOG_API_KEY} options={posthogOptions}>
                {children}
            </PostHogProvider>
        );
    }

    return <>{children}</>;
};

export default PostHogWrapper;
